module.exports = { "default": require("core-js/library/fn/math/log2"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/core-js/math/log2.js
// module id = 248
// module chunks = 0